import { CorsiRoutes } from 'src/app/modules/corsi/corsi.app-manager-routes';
import { createMenuCmdField, EntityManagerConfig } from '../models/entity-config';

export class CorsiEMC extends EntityManagerConfig {
  override initFields(): void {
    this.cmdFields = [createMenuCmdField(CorsiRoutes.EduCorsoListCorsi)];
  }
}
